export default __webpack_public_path__ + "static/media/flag-42582_1280.08fbe408.png";